module.exports = __webpack_public_path__ + "img/icon-description.61583afa.svg";